import { useContext } from 'react';
import { FormsRegisterContext } from './context.ts';

/** Returns the forms register; throws if used outside a FormsRegisterProvider. */
export function useActiveForms() {
  const formsRegisterContext = useContext(FormsRegisterContext);
  if (!formsRegisterContext)
    throw new Error(
      'useActiveForms must be used within a FormsRegisterProvider',
    );
  return formsRegisterContext.formsRegister;
}
